// 角色定位选项 - 全局唯一定义
export const ROLE_OPTIONS = [
  { value: 'host', label: 'Host', color: 'gold' },
  { value: 'regular bishop', label: 'Regular Bishop', color: 'purple' },
  { value: 'attacker', label: 'Attacker', color: 'red' },
  { value: 'sed bishop', label: 'Sed Bishop', color: 'magenta' },
  { value: 'sed target', label: 'Sed Target', color: 'volcano' },
  { value: 'sed mule', label: 'Sed Mule', color: 'orange' },
  { value: 'echo mule', label: 'Echo Mule', color: 'cyan' },
  { value: 'in cave echo', label: 'In Cave Echo', color: 'blue' },
  { value: 'mw30 owner', label: 'MW30 Owner', color: 'lime' },
  { value: 'bucc mule', label: 'Bucc Mule', color: 'geekblue' },
  { value: 'split punishment small', label: 'Split Punishment Small', color: 'orange' },
  { value: 'split punishment medium', label: 'Split Punishment Medium', color: 'volcano' },
  { value: 'split punishment large', label: 'Split Punishment Large', color: 'red' },
  { value: 'reg buyer', label: 'Reg Buyer', color: 'default' },
  { value: 'afk buyer', label: 'AFK Buyer', color: 'default' },
];

// 掉落物品图标映射（物品名 -> 图标文件路径，位于 public/ 目录）
export const ITEM_ICONS = {
  '胖子4': '/mysterious-coin-pouch-4.png',
  'MW20': '/maple-warrior-20.png',
  'GEN30': '/genesis-30.png',
  '手攻30': '/dark-scroll-for-gloves-for-att-30.png',
};

// 获取物品图标路径，无对应图标返回 null
export const getItemIcon = (name) => ITEM_ICONS[name] || null;
